/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Card, Layout, Button, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import withBlockCanDismiss from './blockCanDismiss';
import feedback from 'src/assets/images/dashboard/feedback.png';
import TypeFormEmbededFeedback from 'src/components/views/common/typeform-embedded-feedback';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;
class Feedback extends Component<ComposedProps> {
  state = {
    actionSurvey: false
  };

  render() {
    const { renderPopover, i18n } = this.props;
    const { actionSurvey } = this.state;

    return (
      <Card>
        <Card.Header title={i18n.translate('AdminHTML.Dashboard.Common.feedback')}>
          <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
        </Card.Header>
        <Card.Section>
          <div className="BC-Feedback__Dashboard">
            <Layout>
              <Layout.Section>
                <TextContainer>
                  <p>
                    {i18n.translate('AdminHTML.Dashboard.Feedback.cardContent', {
                      nt_new_line_character: <br />
                    })}
                  </p>
                  <Button onClick={this.leaveFeedback}>
                    {i18n.translate('AdminHTML.Dashboard.Feedback.buttonChildren')}
                  </Button>
                </TextContainer>
              </Layout.Section>
              <Layout.Section secondary>
                <div className="BC-Illustration-Image__Dashboard">
                  <img src={feedback} alt={i18n.translate('AdminHTML.Dashboard.Common.feedback')} />
                </div>
              </Layout.Section>
            </Layout>
            <TypeFormEmbededFeedback type="feedback" conditionShowStateChange={actionSurvey} />
          </div>
        </Card.Section>
      </Card>
    );
  }

  leaveFeedback = () => {
    const { actionSurvey } = this.state;

    this.setState({ actionSurvey: !actionSurvey });
  };
}

export default withBlockCanDismiss(withI18n()(Feedback));
